/* Spanish catalog mirroring locale-autopilot-year-end-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'ap.yearEnd.title': 'Cierre del ejercicio {{year}}',
  'ap.yearEnd.progress': 'Progreso del cierre del ejercicio',
  'ap.yearEnd.step.summary': 'Resumen',
  'ap.yearEnd.step.review': 'Preguntas',
  'ap.yearEnd.step.additions': 'Adiciones',
  'ap.yearEnd.step.final': 'Aprobar',
  'ap.yearEnd.step.submission': 'Presentación',
  'ap.yearEnd.summaryTitle': 'He revisado la base del cierre del ejercicio',
  'ap.yearEnd.summaryText': 'Solo tienes que gestionar las partidas que no pueden resolverse con seguridad a partir de los datos de Plumme.',
  'ap.yearEnd.approved': 'Revisado y en orden',
  'ap.yearEnd.notApplicable': 'No aplicable',
  'ap.yearEnd.needsYou': 'Requiere atención',
  'ap.yearEnd.startReview': 'Gestionar {{count}} partidas',
  'ap.yearEnd.continueAdditions': 'Continuar con las adiciones',
  'ap.yearEnd.questionCount': 'Quedan {{total}} partidas',
  'ap.yearEnd.startReviewGroups': 'Gestionar {{count}} grupos',
  'ap.yearEnd.groupCount': 'Quedan {{total}} grupos',
  'ap.yearEnd.confirmReviewed': 'Lo he revisado y lo confirmo',
  'ap.yearEnd.changeSomething': 'Necesito cambiar algo',
  'ap.yearEnd.openWorkArea': 'Abrir el área de trabajo correspondiente',
  'ap.yearEnd.askAboutThis': 'Preguntar a la IA sobre esto',
  'ap.yearEnd.handleCheck': 'Gestionar',
  'ap.yearEnd.backToFlow': 'Volver al cierre del ejercicio',
  'ap.yearEnd.openAsPage': 'Abrir a página completa',
  'ap.yearEnd.workAreaNote': 'Las comprobaciones se actualizan según lo que hagas aquí.',
  'ap.yearEnd.reviewDone': 'Todas las partidas de revisión están resueltas',
  'ap.yearEnd.reviewDoneText': 'Ahora comprobamos si tienes información que no está disponible en Plumme.',
  'ap.yearEnd.completeness': 'Comprobación de integridad',
  'ap.yearEnd.anythingElse': '¿Hay algo más que añadir?',
  'ap.yearEnd.anythingElseText': 'Descríbelo con tus propias palabras. La IA ayuda a localizar el área adecuada, pero no cambia nada hasta que hayas revisado y aprobado la propuesta.',
  'ap.yearEnd.additionPlaceholder': 'Por ejemplo: compramos una furgoneta en diciembre, pero la factura llegó en enero.',
  'ap.yearEnd.findAddition': 'Encontrar la adición correcta',
  'ap.yearEnd.showAllAdditions': 'Mostrar todas las adiciones',
  'ap.yearEnd.noMore': 'No, no tengo nada más que añadir',
  'ap.yearEnd.finalControl': 'Revisión final',
  'ap.yearEnd.readyTitle': 'El cierre del ejercicio está listo para su aprobación',
  'ap.yearEnd.result': 'Resultado del ejercicio',
  'ap.yearEnd.backToReview': 'Gestionar las partidas pendientes',
  'ap.yearEnd.completeAdditions': 'Completar la comprobación de adiciones',
  'ap.yearEnd.closeYear': 'Aprobar y cerrar el ejercicio contable',
  'ap.yearEnd.closing': 'Cerrando …',
  'ap.yearEnd.closedToast': 'El ejercicio contable se ha cerrado.',
  'ap.yearEnd.saveError': 'No se pudo guardar el flujo del cierre del ejercicio.',
  'ap.yearEnd.closeError': 'No se pudo cerrar el ejercicio contable.',
  'ap.yearEnd.submissionTitle': 'El ejercicio contable está cerrado',
  'ap.yearEnd.filedTitle': 'El proceso de cierre del ejercicio ha terminado',
  'ap.yearEnd.submissionText': 'Continúa con la declaración de impuestos y las cuentas anuales. Los cambios posteriores usan por ahora la vista completa.',
  'ap.yearEnd.ai.title': 'Pregunta a SuperPlumma',
  'ap.yearEnd.ai.context': 'La conversación sigue este proceso de cierre del ejercicio y la partida en revisión.',
  'ap.yearEnd.ai.empty': 'Pregunta por qué importa la partida, qué significa un término o describe algo que creas que falta.',
  'ap.yearEnd.ai.placeholder': '¿Qué te gustaría saber?',
  'ap.yearEnd.ai.ask': 'Preguntar',
  'ap.yearEnd.ai.thinking': 'Comprobando …',
  'ap.yearEnd.ai.error': 'No se pudo obtener una explicación en este momento.',
  'ap.yearEnd.ai.noAnswer': 'No he encontrado una respuesta segura. Abre la vista completa para revisarlo manualmente.',
  'ap.yearEnd.ai.proposalTitle': 'Partida fiscal propuesta',
  'ap.yearEnd.ai.assetGroup': 'Grupo de amortización fiscal',
  'ap.yearEnd.ai.description': 'Descripción',
  'ap.yearEnd.ai.openingValue': 'Valor inicial',
  'ap.yearEnd.ai.acquisition': 'Adquisición',
  'ap.yearEnd.ai.improvement': 'Mejora',
  'ap.yearEnd.ai.proceeds': 'Importe de la venta',
  'ap.yearEnd.ai.depreciation': 'Amortización',
  'ap.yearEnd.ai.amount': 'Importe',
  'ap.yearEnd.ai.bookPrevious': 'Valor contable del año pasado',
  'ap.yearEnd.ai.taxPrevious': 'Valor fiscal del año pasado',
  'ap.yearEnd.ai.bookCurrent': 'Valor contable de este año',
  'ap.yearEnd.ai.taxCurrent': 'Valor fiscal de este año',
  'ap.yearEnd.ai.approvalNote': 'No se guarda nada hasta que lo apruebes. La partida se valida de nuevo al guardarla.',
  'ap.yearEnd.ai.approve': 'Aprobar y añadir',
  'ap.yearEnd.ai.saved': 'La partida fiscal se añadió al borrador. Puedes describir más información si falta algo más.',
  'ap.yearEnd.ai.savedToast': 'Partida fiscal añadida',
  'ap.yearEnd.ai.saveError': 'No se pudo guardar la partida fiscal.',
  'ap.yearEnd.ai.draftInProgress': 'Propuesta en curso',
  'ap.yearEnd.ai.cancelDraft': 'Terminar',
  'ap.agentName.bookkeeping': 'Agente de contabilidad',
  'ap.agentName.tax': 'Agente de impuestos',
  'ap.agentName.annual': 'Agente de cuentas anuales',
  'ap.followup.bank': 'Conciliación bancaria',
  'ap.followup.title': 'Seguimiento',
  'ap.followup.countOne': '{{count}} partida requiere atención.',
  'ap.followup.countMany': '{{count}} partidas requieren atención.',
  'ap.agent.tax.titleMissing': 'Faltan {{count}} requisito(s) previo(s) a la declaración de impuestos',
  'ap.agent.annual.titleMissing': 'Faltan {{count}} requisito(s) previo(s) a las cuentas anuales',
  'ap.readiness.yearOpen': 'El ejercicio fiscal no está cerrado',
  'ap.readiness.yearOpenSub': 'El cierre del ejercicio no se ha completado',
  'ap.readiness.inbox': '{{count}} justificantes no se han procesado por completo',
  'ap.readiness.inboxSub': 'Completa la bandeja de entrada antes de la presentación anual',
  'ap.readiness.bank': '{{count}} líneas bancarias no están totalmente conciliadas',
  'ap.readiness.bankSub': 'Completa la conciliación bancaria',
  'ap.readiness.previousTax': 'La declaración de impuestos anterior no se ha confirmado como presentada',
  'ap.readiness.reviewYear': 'Revisar {{year}}',
  'ap.review.all': 'Todos',
  'ap.review.withVoucher': 'Con justificante',
  'ap.review.matched': 'Conciliado',
  'ap.review.missingVoucher': 'Falta el justificante',
  'ap.review.needsChecking': 'Requiere comprobación',
  'ap.review.createsDeviation': 'Genera una discrepancia',
  'ap.review.upToDate': 'Al día',
  'ap.review.approvedNotPosted': 'Aprobado · sin contabilizar',
  'ap.review.blocked': 'Bloqueado',
  'ap.review.ready': 'Listo',
  'ap.review.yourAccounts': 'Tus cuentas',
  'ap.review.exampleData': 'Datos de ejemplo',
  'ap.review.voucherLinked': '✓ Justificante vinculado',
  'ap.review.hideVoucher': 'Ocultar justificante',
  'ap.review.showVoucher': 'Mostrar justificante',
  'ap.review.allVouchersLinked': 'Todos los justificantes están vinculados 🎉',
  'ap.review.deadline': 'Plazo',
  'ap.review.readyForApproval': 'Listo para su aprobación',
  'ap.surface.fullscreen': 'Ver a pantalla completa',
  'ap.surface.exitFullscreen': 'Salir de pantalla completa',
  'ap.surface.voucherCount': '{{count}} justificantes',
  'ap.surface.outsideMonth': '{{count}} fuera del mes',
  'ap.surface.accountsAndVouchers': 'Cuentas y justificantes sin línea bancaria',
  'ap.yearEnd.bank.title': 'Conciliación bancaria {{year}}',
  'ap.yearEnd.bank.note': 'Elige el mes que quieres comprobar para este cierre del ejercicio.',
  'ap.yearEnd.bank.openLines': '{{count}} líneas bancarias abiertas',
  'ap.yearEnd.bank.missingStatements': 'A {{count}} cuentas bancarias les falta un extracto',
  'ap.yearEnd.bank.done': 'Conciliado y archivado',
  'ap.yearEnd.bank.needsArchive': 'Comprobar el archivado',
  'ap.yearEnd.bank.noStatement': 'Sin extracto bancario',
  'ap.yearEnd.backToWorkArea': 'Volver a {{title}}',
  'ap.surface.bankUploadUnavailable': 'Subir un extracto bancario aún no está disponible.',
  'ap.surface.bankReadError': 'No se pudo leer el extracto bancario.',
  'ap.surface.bankLoadErrorTitle': 'No se pudo cargar la conciliación',
  'ap.surface.bankLoadErrorDetail': 'Recarga la página o abre el extracto desde Banco.',
  'ap.surface.assetMovedToExpense': 'El justificante se ha retirado de la revisión de activos. Comprueba la cuenta y el IVA en la lista de contabilidad.',
  'ap.surface.assetSkipError': 'No se pudo omitir el registro del activo.',
  'ap.surface.assetTitle': 'Posibles activos fijos',
  'ap.surface.assetSubtitle': '{{count}} justificante(s) por encima del umbral',
  'ap.surface.assetEmptyTitle': 'No quedan sugerencias de activos',
  'ap.surface.assetChooseHelp': 'Elige si el justificante debe registrarse como activo fijo o devolverse a la revisión contable habitual. La compra solo se contabiliza una vez.',
  'ap.surface.assetNotAsset': 'No es un activo fijo',
  'ap.surface.inboxTitle': 'La bandeja de justificantes',
});
